/** @format */

export const CONSTANTS_ASSETS_EMP_WEB_EXP = {
  IMAGES: {
    EMPTY_HERO: "assets/libraries/mis-employee-web-exp/images/empty-booking-card.svg",
    MOBILE_EMPTY_HERO: "assets/libraries/mis-employee-web-exp/images/mobile-empty-booking-card.png",
    NO_UPCOMING: "assets/libraries/mis-employee-web-exp/images/upcoming-bookings.svg",
    HERO_BG: "assets/libraries/mis-employee-web-exp/images/hero-BG.svg",
    EMPTY_PLATE: "assets/libraries/mis-employee-web-exp/images/empty-plate.svg",
    PARKING_BG: "assets/libraries/mis-employee-web-exp/images/parking-bg.svg",
    CERTIFICATE: "assets/libraries/mis-employee-web-exp/images/certificate.svg",
    BOOKING_SUCCESS: "assets/libraries/mis-employee-web-exp/images/booking-success.svg",
    HISTORY_EMPTY: "assets/libraries/mis-employee-web-exp/images/history-empty-state.svg",
    NO_PARKING_SLOTS: "assets/libraries/mis-employee-web-exp/images/no-data-160.svg"
  },
  ICONS: {
    MORE: "assets/libraries/mis-employee-web-exp/icons/ic-action-more-vert.svg",
    CANCELLED: "assets/libraries/mis-employee-web-exp/icons/ic-nav-cancelled-24.svg",
    CANCEL_INFO: "assets/libraries/mis-employee-web-exp/icons/ic-ui-cancel-info-24.svg",
    DOWN_ARROW: "assets/libraries/mis-employee-web-exp/icons/down-arrow.svg",
    HERO_RIGHT: "assets/libraries/mis-employee-web-exp/icons/ic-navigation-chevron-right-blue-24.svg",
    SEAT: "assets/libraries/mis-employee-web-exp/icons/seat.svg",
    CLOSE: "assets/libraries/mis-employee-web-exp/icons/close-popup.svg",
    CALENDAR: "assets/libraries/mis-employee-web-exp/icons/ic-rep-calendar.svg",
    CAB: "assets/libraries/mis-employee-web-exp/icons/ic-ui-car-24.svg",
    CAB_DARK: "assets/libraries/mis-employee-web-exp/icons/ic-ui-transport-black-24.svg",
    TICK_GREEN: "assets/libraries/mis-employee-web-exp/icons/ic-tick-green.svg",
    SUCCESS_TICK: "assets/libraries/mis-employee-web-exp/icons/ic-ui-success-24.svg",
    ARROW: "assets/libraries/mis-employee-web-exp/icons/arrow.svg",
    EDIT: "assets/libraries/mis-employee-web-exp/icons/ic-action-edit-16.svg",
    EDIT_DARK: "assets/libraries/mis-employee-web-exp/icons/edit_dark.svg",
    CANCEL: "assets/libraries/mis-employee-web-exp/icons/Union.svg",
    IC_RADIO: "assets/libraries/mis-employee-web-exp/icons/ic-selection-radio.svg",
    IC_RADIO_ACTIVE: "assets/libraries/mis-employee-web-exp/icons/ic-selection-radio-active.svg",
    IC_ADD: "assets/libraries/mis-employee-web-exp/icons/ic-action-add-24.svg",
    IC_CLOSE: "assets/libraries/mis-employee-web-exp/icons/ic-navigation-cancel-24.svg",
    IC_WFO: "assets/libraries/mis-employee-web-exp/icons/ic-nav-office-24.svg",
    IC_WFH: "assets/libraries/mis-employee-web-exp/icons/ic-sidebar-home-24.svg",
    DESK: "assets/libraries/mis-employee-web-exp/icons/ic-nav-desk-mgmt-24.svg",
    DESK_BULE: "assets/libraries/mis-employee-web-exp/icons/desk.svg",
    DESK_GREY: "assets/libraries/mis-employee-web-exp/icons/ic-nav-desk-mgmt-grey-24.svg",
    CHEVRON_RIGHT: "assets/libraries/mis-employee-web-exp/icons/ic-navigation-chevron-right-24.svg",
    CANCEL_BIN: "assets/libraries/mis-employee-web-exp/icons/cancelbin.svg",
    WFH: "assets/libraries/mis-employee-web-exp/icons/wfh.svg",
    WFO_CONVERT: "assets/libraries/mis-employee-web-exp/icons/ic-convert-WFO-24.svg",
    WFH_CONVERT: "assets/libraries/mis-employee-web-exp/icons/convert-booking-wfo.svg",
    WFO_CONVERT_DARK: "assets/libraries/mis-employee-web-exp/icons/ic-convert-WFO-24.svg",
    WFH_CONVERT_DARK: "assets/libraries/mis-employee-web-exp/icons/convert-booking-wfo-dark.svg",
    QUICK_WFH: "assets/libraries/mis-employee-web-exp/icons/quick-wfh.svg",
    QUICK_WFO: "assets/libraries/mis-employee-web-exp/icons/quick-wfo.svg",
    CLOCK: "assets/libraries/mis-employee-web-exp/icons/ic-action-shift time-24.svg",
    PARKING: "assets/libraries/mis-employee-web-exp/icons/ic-ui-parking-24-blue.svg",
    PARKING_ACTIVE: "assets/libraries/mis-employee-web-exp/icons/ic-ui-parking-24-white.svg",
    TRANSPORT: "assets/libraries/mis-employee-web-exp/icons/ic-ui-transport-24-blue.svg",
    TRANSPORT_ACTIVE: "assets/libraries/mis-employee-web-exp/icons/ic-ui-transport-24-white.svg",
    TRANSPORT_UNAVAILABILTY: "assets/libraries/mis-employee-web-exp/icons/ic-new-icon-transport-availibilty.svg",
    TRANSPORT_AVAILABILTY: "assets/libraries/mis-employee-web-exp/icons/ic-new-icon-transport-Availibilty-V1-32.svg",
    INFO: "assets/libraries/mis-employee-web-exp/icons/ic-ui-info-24.svg",
    RED_INFO: "assets/libraries/mis-employee-web-exp/icons/ic-action-red-info-24.svg",
    CHOICE_CHIP: "assets/libraries/mis-employee-web-exp/icons/ic-ui-check-24.svg",
    MEAL: "assets/libraries/mis-employee-web-exp/icons/ic-ui-meal-24.svg",
    MEAL_DARK: "assets/libraries/mis-employee-web-exp/icons/ic-ui-meal-24-dark.svg",
    MEAL_CHECK: "assets/libraries/mis-employee-web-exp/icons/ic-ui-check-24.svg",
    AVATAR: "assets/libraries/mis-employee-web-exp/icons/avatar.svg",
    PARKING_MODULE: "assets/libraries/mis-employee-web-exp/icons/ic-ui-hero-parking-24.svg",
    APPROVAL_STATUS: "assets/libraries/mis-employee-web-exp/icons/ic-ui-approval-info-24.svg",
    SUCCESS_RECURRENCE: "assets/libraries/mis-employee-web-exp/icons/ic-ui-approvals2-24.svg",
    FAILED_BOOKINGS: "assets/libraries/mis-employee-web-exp/icons/ic-ui-cross-24.svg",
    MORE_STATUS: "assets/libraries/mis-employee-web-exp/icons/status-navigation.svg",
    LANGUAGE: "assets/libraries/mis-employee-web-exp/icons/language_black.svg",
    SHUTTLE_ACTIVE: "assets/libraries/mis-employee-web-exp/icons/shuttleActive.svg",
    SHUTTLE: "assets/libraries/mis-employee-web-exp/icons/shuttle.svg",
    SHUTTLE_DEACTIVE: "assets/libraries/mis-employee-web-exp/icons/shuttleDeactive.svg",
    SHUTTLE_DARK: "assets/libraries/mis-employee-web-exp/icons/shuttleDark.svg",
    SHUTTLE_CROSS: "assets/libraries/mis-employee-web-exp/icons/shuttleCross.svg",
    ACTION_INFO: "assets/libraries/mis-employee-web-exp/icons/ic-action-info-24.svg",
    TRANSPORT_BIKE: "assets/libraries/mis-employee-web-exp/icons/ic-ui-bike-24.svg",
    TRANSPORT_CAR: "assets/libraries/mis-employee-web-exp/icons/ic-ui-transport-24.svg",
    WFO_HEADER: "assets/libraries/mis-employee-web-exp/icons/wfo-header.svg",
    WFH_HEADER: "assets/libraries/mis-employee-web-exp/icons/wfh-header.svg",
    CROSS_MODAL: "assets/libraries/mis-employee-web-exp/icons/modal-cross.svg",
    LIST: "assets/libraries/mis-employee-web-exp/icons/list.svg",
    NOTE: "assets/libraries/mis-employee-web-exp/icons/inventory.svg",
    CAR_BLACK: "assets/libraries/mis-employee-web-exp/icons/car_black.svg",
    CAR_SELECTED: "assets/libraries/mis-employee-web-exp/icons/car_selected.svg",
    BIKE_BLACK: "assets/libraries/mis-employee-web-exp/icons/bike_black.svg",
    BIKE_SELECTED: "assets/libraries/mis-employee-web-exp/icons/bike_selected.svg",
    PARKING_HEADER: "assets/libraries/mis-employee-web-exp/icons/parkingHeader_icon.svg",
    PARKING_ACTION: "assets/libraries/mis-employee-web-exp/icons/parkingAction_icon.svg",
    EMPTY_STAR:"assets/libraries/mis-employee-web-exp/icons/emptyStar.svg",
    SELECTED_STAR: "assets/libraries/mis-employee-web-exp/icons/selectedStar.svg",
    STAR: "assets/libraries/mis-employee-web-exp/icons/star.svg",
    HORRIBLE: "assets/libraries/mis-employee-web-exp/icons/horrible.svg",
    AVERAGE: "assets/libraries/mis-employee-web-exp/icons/average.svg",
    BAD: "assets/libraries/mis-employee-web-exp/icons/bad.svg",
    EXCELLENT: "assets/libraries/mis-employee-web-exp/icons/excellent.svg",
    GOOD: "assets/libraries/mis-employee-web-exp/icons/good.svg",
    MEAL_EMPTY_FEEDBACK : "assets/libraries/mis-employee-web-exp/icons/MEAL_EMPTY_FEEDBACK.svg"
  }
};
